import Request from '../../data/request'
import isMoment from "../../utils/datetime/is-moment"

export default class ApiEvents {

    constructor() {

    }

    getEvent(eventId:ID) {
        return new Request(this,'GET','event/'+eventId);
    }

    viewEvent(eventId:ID) {
        return new Request(this,'GET','event/{0}/view'.f(eventId), {}, true, false);
    }

    // couldn't find usages... is it old ?
    all(startMoment:Moment,endMoment:Moment) {
        return new Request(this,'GET','events',{
            startDate: gd.utils.momentToDate(startMoment),
            endDate: gd.utils.momentToDate(endMoment)
        });
    }

    assignTo(eventId:ID, userId:ID) {
        return new Request(this,'put','event/'+eventId+'/assign',{
            'userId': userId
        });
    }

    setStartEnd(eventId:ID, startMoment:Moment | null, endMoment:Moment | null) {
        return new Request(this, 'PUT', 'event/'+eventId+'/start-end', {
            startDate: gd.utils.momentToDate(startMoment),
            endDate: gd.utils.momentToDate(endMoment)
        });
    }

    static create(params:any) {


        // Prepare dates
        if (isMoment(params.startDate)) {
            params.startDate = gd.utils.momentToDate(params.startDate);
        }
        if (params.endDate && isMoment(params.endDate)) params.endDate = gd.utils.momentToDate(params.endDate);

        const request = new Request(this,'post','events',params);

        request.done(response=>{
            gd.growl.eventCreated(response.id, response.name);
        });

        return request;
    }

    deleteEvent(eventId:ID) {
        return new Request(this,'DELETE','event/'+eventId)
    }

    setName(eventId:ID, name:string) {
        return new Request(this, 'PUT', 'event/{0}/update'.f(eventId), {name});
    }

    setNotes(eventId:ID, notes:string) {
        return new Request(this,'PUT','event/{0}/notes'.f(eventId),{notes});
    }

    setAccomplished(eventId:ID, isAccomplished:boolean) {
        return new Request(this,'PUT','event/{0}/accomplished'.f(eventId),{isAccomplished});
    }

    setProjectId(eventId:ID, projectId:ID) {
        return new Request(this, 'PUT', 'event/{0}/update'.f(eventId), {projectId});
    }

    static getEvents(params: any) {

        /*params: {
            "startDate": "2025-04-01",
            "endDate": "2025-05-01",
            "projectIds": ["OGWUt5"],
            "entities": [
                {
                    "entityType": 3, // EntityType.EVENT
                    "eventSystemType": "personal",
                    "eventTypes": [20, 21, 22, 23, 24],
                    "userIds": ["xcCyuq"]
                },
                {
                    "entityType": 3,
                    "eventSystemType": "company",
                    "eventTypes": [10, 11]
                },
                {
                    "entityType": 3,
                    "eventSystemType": "project",
                    "eventTypes": [1, 2, 3, 4, 5],
                    "assignedToUserIds": []
                },
                {
                    "entityType": 4,// EntityType.METTING
                    "userIds": ["xcCyuq"]
                },
                {
                    "entityType": 1,
                    "systemField": "deadline",
                    "assignedToUserIds": ["xcCyuq"],
                    "actionRequiredUserIds": []
                },
                {
                    "entityType": 1,// EntityType.TASK
                    "systemField": "start-end",
                    "assignedToUserIds": ["xcCyuq"],
                    "actionRequiredUserIds": []
                },
                {
                    "entityType": 1,
                    "systemField": "schedule",
                    "assignedToUserIds": ["xcCyuq"],
                    "actionRequiredUserIds": []
                },
                {
                    "entityType": 1,
                    "customFieldId": "D39XxO",
                    "assignedToUserIds": ["xcCyuq"],
                    "actionRequiredUserIds": []
                },
                {
                    "entityType": 1,
                    "customFieldId": "FaahP4",
                    "assignedToUserIds": [],
                    "actionRequiredUserIds": ["xcCyuq"]
                }
            ],
            "taskFields": [
                "tags",
                "users"
            ]
        }*/
        return new Request(this, 'POST','uds/v2/events', params)
    }
}

